import {
  Grid,
  Box,
  FormControl,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogCustom from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogWait";
import {
  getData,
  storeData,
  checkEditPage,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import ChildList from "../../components/ChoiceComponent/ChildList";
import { checkIdcard } from "../../utils/formatter";
import ErrorIcon from "@mui/icons-material/Error";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import { isEmpty } from "lodash";

const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  subTitleGray: {
    fontFamily: "DB Heavent",
    fontSize: "18px",
    color: "var(--gray)",
    marginTop: "6px",
  },
  radioCustom: {
    width: "100% !important",
    "& label": {
      marginLeft: "0px !important",
      borderBottom: "solid 1px #ccc",
    },
  },
  flexAlign: {
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: "6px",
      color: "var(--lemon)",
    },
  },
});
const FamilyStatusChild = (props) => {
  const classes = useStyle();
  const defaultChild = [
    {
      cardId: "",
      firstName: "",
      lastName: "",
      birthDate: "",
    },
  ];
  const idc = getData("idc");
  const family_status = getData("family_status");
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalHaveAccount, setIsModalHaveAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [childList, setChildList] = useState(
    getData("childList") ? getData("childList").data : defaultChild,
  );
  const [radioChild, setRadioChild] = useState(
    getData("childList") ? getData("childList").radio : "",
  );
  const [validateChild, setValidateChild] = useState(!getData("childList"));
  const currentPage = getData("currentStep");
  const [editUrl, setEditUrl] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const career = getData("f3_career");
  const status = getData("family_status");
  let snapIdCard = getData("uploadImage");

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
      }
    });
  }, []);

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const radioHandleChange = (e) => {
    setRadioChild(e.target.value);
    setChildList(defaultChild);
    setValidateChild(e.target.value === "1");
  };
  const handleNext = async () => {
    const found = childList.some((el) => {
      let check = 0;
      childList.forEach((element, i) => {
        if (element.cardId === el.cardId) check++;
      });
      if (
        !checkIdcard(el.cardId) ||
        el.cardId === idc?.idCard ||
        check > 1 ||
        el.cardId === family_status?.f1_spouse_id_card
      ) {
        return true;
      } else {
        return false;
      }
    });
    setIsSubmit(true);
    if (!found || radioChild === "0") {
      storeData("childList", { radio: radioChild, data: childList });
      await checkEditPage().then((res) => {
        if (res) {
          setIsLoading(true);
          const head_token = getData("HeaderManp")
            ? getData("HeaderManp")?.head_token
            : "";
          const childList = getData("childList");
          let children_json = [];
          if (childList.radio !== "0") {
            childList?.data?.forEach((row) => {
              children_json.push({
                SAfc_THName: row?.firstName,
                SAfc_THSurname: row?.lastName,
                SAfc_CardID: row?.cardId,
                SAfc_Birthdate: row?.birthDate,
              });
            });
          }

          const data = {
            head_token,
            children_json,
          };
          const header = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          try {
            GlobalApi.post(
              `${Configs.baseAPIURL03}/form/children/manp`,
              data,
              header,
            )
              .then((res) => {
                setIsLoading(false);
                if (res.data.Data[0][0].IsSuccess === 1) {
                  storeData("editPage", "childList");
                  props.history.push("/summary");
                }
              })
              .catch((e) => {
                setModalErrorDes(e);
                setIsModalError(true);
                setIsLoading(false);
              });
          } catch (error) {
            setModalErrorDes(error);
            setIsModalError(true);
            setIsLoading(false);
          }
        } else {
          props.history.push("/invest_info_income");
        }
      });
    }
  };
  const showDialogAge = () => {
    setIsModalHaveAccount(true);
  };
  const popUps = async (val) => {};
  const onChangeChild = (e) => {
    setChildList(e);
    setValidateChild(checkValidateChild(e));
  };
  const checkValidateChild = (items) => {
    const validation = items.every(
      (item) =>
        item.cardId && item.firstName && item.lastName && item.birthDate,
    );
    return !validation;
  };
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.family?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/status") : "")}
          />
          <Loading status={isLoading} />
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            switchType={(e) => popUps(e)}
            title={"ท่านอยู่ระหว่างการเปิดบัญชี"}
            btnPrimary={"กรอกข้อมูลใหม่"}
            btnSecondary={"ดำเนินการต่อ"}
          />
          <DialogCustom
            open={isModalHaveAccount}
            title={"บุตรที่ยังไม่บรรลุนิติภาวะ"}
            massage="บุตรที่มีอายุต่ำกว่า 20 ปีบริบูรณ์"
            isModel={setIsModalHaveAccount}
            btnPrimary={"กลับ"}
          />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.family}
                        clickBack={(e) => props.history.push("/status")}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid   className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}>
                          <HeaderRight
                            title={translations?.[lang]?.family?.title}
                          />
                          <ScrollBarComponent
                            isCheck={isCheck}
                            onChangeCheck={setIscheck}
                            content={
                              <Box>
                                <Typography
                                  className={clsx(
                                    classes.flexAlign,
                                    "font-title",
                                  )}
                                >
                                  คุณมีบุตรที่ยังไม่บรรลุนิติภาวะหรือไม่
                                  {isMobile && (
                                    <ErrorIcon onClick={showDialogAge} />
                                  )}
                                </Typography>
                                {!isMobile && (
                                  <div className={classes.subTitleGray}>
                                    *บุตรอายุต่ำกว่า 20 ปีบริบูรณ์
                                  </div>
                                )}

                                <Grid className="input-form">
                                  <FormControl
                                    component="fieldset"
                                    className={classes.radioCustom}
                                  >
                                    <RadioGroup
                                      aria-label="gender"
                                      name="radio-buttons-group"
                                      value={radioChild}
                                      onChange={radioHandleChange}
                                    >
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio />}
                                        label="ไม่มี"
                                      />
                                      <FormControlLabel
                                        style={{
                                          borderBottom:
                                            radioChild === "1"
                                              ? "0px"
                                              : "solid 1px #ccc",
                                        }}
                                        value="1"
                                        control={<Radio />}
                                        label="มี"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  {radioChild === "1" && (
                                    <ChildList
                                      valid={isSubmit}
                                      list={childList}
                                      handleChange={onChangeChild}
                                    />
                                  )}
                                </Grid>
                                <Grid className="input-form"></Grid>
                              </Box>
                            }
                          ></ScrollBarComponent>{" "}
                          <ButtonRight
                            isDisbled={validateChild}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.family?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(FamilyStatusChild);
